package com.appsyde.shared.presentation.style.style


import com.appsyde.shared.presentation.style.animations.AppStylesAnimations
import org.jetbrains.compose.web.css.*

object AppStylesProgress : StyleSheet() {

    val progressOverlay by style {
        position(Position.Absolute)
        property("inset", "0")
        borderRadius(16.px)
        property("display", "flex")
        property("align-items", "center")
        property("justify-content", "center")
    }

    val progressBarContainer by style {
        width(220.px)
        height(8.px)
        borderRadius(999.px)
        backgroundColor(Color("#ECEEF6"))
        property("overflow", "hidden")
    }

    val progressBarIndicator by style {
        height(100.percent)
        width(36.percent)
        borderRadius(999.px)
        property(
            "background",
            "linear-gradient(90deg, rgba(255,255,255,0.0), rgba(255,255,255,0.6), rgba(255,255,255,0.0))"
        )
        property("transform", "translate3d(-100%,0,0)")
        property("will-change", "transform")
        property("animation", "${AppStylesAnimations.appsydeProgress.name} 1.8s linear infinite")
    }
}
